import PropTypes from 'prop-types';
import CanvasDownload from '~/js/modules/canvasDownload';
import SocialShare, { linkFacebook, linkPinterest } from '~/js/modules/share-social';
import QuickQuote from '~/js/components/global/QuickQuote';

const { Fragment } = React;

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);
const { resortSummary } = window.beaches_app.page;

const convertImage = () => {
  if(!isMobile) {
    const downloadImg = document.querySelector('.js-img');
    const imgObject = new CanvasDownload('.js-img', '.js-download');

    downloadImg.classList.add('download-img');
    imgObject.createCanvas();
    imgObject.createWaterMark();

    const watermark = document.querySelector('#watermark');

    watermark.addEventListener('load', () => imgObject.convertImageToCanvas('.js-img'));
  }
};

const DetailsView = (props) => {
  const {
    data: {
      eventId = '',
      groupId = '',
      rstCode = '',
      resortCodeList = [],
      eventName = '',
      mainImages = {},
      livPlusEventDateWithoutHtml,
      additionalNotes = '',
      resortInfo,
      modalContent,
      descriptionWithoutHtml = '',
      padiIncludes = [],
      rates = [],
    },
    onBackClicked
  } = props;
  const { cdn_url: cdnURL } = window.beaches_app.global;
  let isBeaches;
  const beachesResorts = ['BTC', 'BNG', 'BBO'];
  const compareWithBeachesResorts = (resortCode) => beachesResorts.includes(resortCode);

  if (typeof rstCode === 'string') {
    isBeaches = rstCode.includes('BTC');
  } else {
    isBeaches = rstCode.every((rst) => compareWithBeachesResorts(rst));
  }

  let eventDescription = <p>{descriptionWithoutHtml}</p>;
  let imageElement = <div className="img-placeholder"><span>No image</span></div>;
  let includes = null;

  if (modalContent) {
    eventDescription = (
      <div
        className="text"
        dangerouslySetInnerHTML={{ __html: modalContent }} />
    );
  }

  if (mainImages.modal) {
    imageElement = (
      <Fragment>
        <img
          crossOrigin="anonymous"
          src={mainImages.modal}
          alt={eventName}
          onLoad={convertImage}
          className="js-img img-responsive"/>
        <figcaption>
          <div className="share">
            Share
            <ul className="link-list">
              <li>
                <a
                  href={linkFacebook}
                  onClick={(e) => SocialShare.doPopup(e, linkFacebook)}>
                  <i className="icon-facebook" />
                </a>
              </li>
              <li>
                <a
                  href={linkPinterest}
                  onClick={(e) => SocialShare.doPopup(e, linkPinterest)}>
                  <i className="icon-pinterest" />
                </a>
              </li>
            </ul>
          </div>
          {!isMobile && <div className="download">
            Download
            <ul className="link-list">
              <li>
                <a
                  href={mainImages.modal}
                  className="js-download"
                  download="Event image.jpg">
                  <i className="icon-download" />
                </a>
              </li>
            </ul>
          </div>}
        </figcaption>
      </Fragment>
    );
  }

  if (padiIncludes.length) {
    includes = (
      <div className="includes">
        <h3 className="title-4">Diving package includes:</h3>
        <ul className="includes-list">
          {padiIncludes.map((el, index) => (
            <li key={index}>{el}</li>
          ))}
        </ul>
      </div>
    );
  }

  if (eventId === 9398) {
    includes = (<div className="description" dangerouslySetInnerHTML={{ __html: additionalNotes }} />);
  }

  return(
    <div className="details container">
      <div className="details-inner">
        <div className="row">
          <div className="xs-12 xxl-7">
            <div className="details-content">
              <h2 className="title-6">{resortInfo || resortSummary[rstCode] && resortSummary[rstCode].resortShortName}</h2>
              <h3 className="title-7">{eventName}</h3>
              <button className="back-btn" onClick={onBackClicked}>
                <i className="icon-button-arrow-prev" />
                Back To lIV+ Events
              </button>

              <figure>
                {imageElement}
              </figure>
            </div>
          </div>
          <div className="xs-12 lg-6 xxl-7">
            <div className="description">
              <h3 className="title-4">{livPlusEventDateWithoutHtml}</h3>

              {eventDescription}
            </div>

            {includes}
          </div>
          <div className="details-aside xs-12 lg-6 xxl-4">
            <img
              src={`${cdnURL}/liv-plus/liv-plus-logo.svg`}
              alt="Luxury included vacation + events" />
            <div className="price">
              ${rates[0].rate} <span>per person <span className="show">(USD)</span></span>
            </div>
            <QuickQuote
              resortsPlaceholder={(!resortCodeList.length && resortInfo) || false}
              reference="oee"
              groupID={groupId}
              eventID={eventId}
              brand={resortInfo === 'All Beaches Resorts' ? 'beaches' : 'all'}
              allowedResortCodes={resortCodeList}
              defaultResortCode={resortCodeList.length === 1 && rstCode}
              schedulerModeIndex={14}
              hasCountries={false}
              quoteButtonText="Continue"
              hasResorts
              hasOccupancy={false}
              resortDisabled={resortCodeList.length === 1}
              startDatePlaceholderText="Select Check-In Date"
              endDatePlaceholderText="Select Check-Out Date"
              resortLabelText="RESORT"
              numberOfMonths={ 1 }
              resortListBrand="all"
              notOeeRequest={isBeaches}
            />
          </div>
        </div>
      </div>

      <button className="back-btn" onClick={onBackClicked}>
        <i className="icon-button-arrow-prev" />
        Back To lIV+ Events
      </button>
    </div>
  );
};

DetailsView.propTypes = {
  data: PropTypes.object,
  onBackClicked: PropTypes.func,
};

DetailsView.defaultProps = {
  data: {},
  onBackClicked: () => {}
};

export default DetailsView;
